import React from "react";
import Controls from "src/components/form/controls/Controls";
import { CACHE_IOT_PARTNER } from "src/constants/actionCache";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import ShowCacheFLFIotPartner from "../ShowCache/ShowCacheFLFIotPartner";
import { useState } from "react";
import FLFIotPartnerPopup from "../Popup/FLFIotPartnerPopup";

const FLFIotPartnerControlPanel = ({
  children,
  isSorted,
  handleSort,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache IotPartner"
          isShowButton={isShowCache(currentActionCache, CACHE_IOT_PARTNER)}
        >
          <ShowCacheFLFIotPartner
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>
        {isSorted ? (
          <Controls.Button
            text="Apply sort"
            variant="outlined"
            onClick={handleSort}
          />
        ) : null}
        <FLFIotPartnerPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default FLFIotPartnerControlPanel;
